// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"report-sender-modal_modalContent__KwHWc","content":"report-sender-modal_content__W10EL","button":"report-sender-modal_button__6hVpY"};